let Search = class {
  elements = {
    container: null,
    searchBox: null,
    dropdown: null,
    resultBox: null,
    filterBox: null,
  };
  data = {
    isLoading: false,
    limit: 5, // Change this to 0 to disable rendering of results
    delayResultsMs: 150, // How long to delay search results
    debounceMs: 40, // How long to debounce search
    lastSearchValue: '',
    hasFilters: false,
    isEditLinkEnabled: true,
  };
  // Title type mappings from Titles.php
  titleTypes = {
    1: 'Film',
    2: 'Season',
    3: 'Episode',
    4: 'Short',
    5: 'Music Video',
    6: 'Trailer',
    7: 'Show',
  };
  // Display order for title types (most common first)
  titleTypeOrder = [1, 7, 2, 3, 4, 5, 6];
  templates = {
    ajaxLoader: `<div class="loady-flat"></div>`,
    results: {
      default: `Type Something...`,
      header: ``, //`<h2 class="standard medium">Results</h2>`,
      modelHeader: (modelName, resultCount, link) => `
                <div class="relative"><button onclick="window.sflow.search.viewAllResults(this)" data-link="${link}" type="submit" class="searchResultModelHeader trans2" data-result-count="${resultCount}">${modelName}: <span>${resultCount}</span></button>
                <hr>
            `,
      titleTypeHeader: (typeName, resultCount) => `
                <div class="searchResultTitleType"><span class="type-name">${typeName}</span> <span class="type-count">(${resultCount})</span></div>
            `,
      preview: {
        container: (results) => `
                    <ul class="split">
                        ${results}
                        <li class="clear" aria-hidden="true"></li>
                    </ul>
                    <hr>
                `,
        row: (resultData, resultHtml, viewLink, editLink, viewSingleLink) => {
          let template = `<li class="s1">`;

          template += `<span class="result"><input type="checkbox" id="${resultData.id}" class="trigger_check">${resultHtml} <span class="links">`;

          if (viewSingleLink !== null) {
            template += `<a href="${viewSingleLink}" class="trans2 rl view" title="View Single"></a>`;
          }
          if (viewLink !== null) {
            template += `<a href="${viewLink}" class="trans2 rl index" title="View Index"></a>`;
          }
          if (editLink !== null && this.data.isEditLinkEnabled) {
            template += `<a href="${editLink}" class="trans2 rl edit" title="Edit"></a>`;
          }

          template += `</span></span></li>`;

          return template;
        },
        column: (key, value, link) => ` 
                    <strong>${key}</strong> 
                    ${value}
                `,
      },
      viewMoreButton: (link) => `<button onclick="window.sflow.search.viewAllResults(this)" data-link="${link}" class="searchViewMoreButton trans2" type="submit">View All</button></div>`,
      noViewMoreEnd: () => `</div>`,
    },
  };

  constructor () {
    var keyupTimeout = null;

    // Bind
    $('input.doesSearch').keyup(
      (e) => {
        clearTimeout(keyupTimeout);
        keyupTimeout = setTimeout(() => {
          this.search(e.target);
        }, 1000);

      },
    ).focus(
      (e) => this.focus(e.target),
    );
  }

  search (target) {
    this.setSearchBox($(target));
    let searchValue = this.elements.searchBox.val();
    // If there is something in the search box and its the same as last time, just show results
    if (searchValue !== '' && searchValue === this.data.lastSearchValue) {
      this.showDropdown();
    } else if (this.elements.searchBox.val() !== '') {
      this.doSearch().then((results) => this.renderResults(results));
    } else if (!this.data.hasFilters) {
      this.hideDropdown();
    }
  }

  focus (target) {
    this.setSearchBox($(target));

    // Bind to window for hide event
    $(window).click((e) => this.blur(e.target));
    this.elements.filterBox.find('input,select').bind(
      'change',
      (e) => this.doSearch().then((results) => this.renderResults(results)),
    );

    if (this.elements.searchBox.val() !== '') {
      this.search(target);
    } else if (this.data.hasFilters) {
      this.showDropdown();
    } else {
      this.hideDropdown();
    }
  }

  blur (target) {
    if (!$(target).closest('.mega').length) {
      $(window).unbind('click');
      this.hideDropdown();
    }
  }

  doSearch () {
    this.setIsLoading(true);
    this.setLastSearchValue(this.elements.searchBox.val());
    let filterData = this.getFilterData();
    let searchData = {
      model: this.elements.searchBox.attr('data-models').split(','),
      query: this.data.lastSearchValue,
      limit: this.data.limit,
    };

    return $.ajax({
      url: '/ajax/search',
      data: { ...filterData, ...searchData },
      cache: false,
    });
  }

  renderDefault () {
    this.elements.resultBox.html(
      this.templates.results.default,
    );
  }

  hideDropdown () {
    this.elements.dropdown.fadeOut();
  }

  hideResults () {
    this.elements.resultBox.fadeOut();
    //this.elements.dropdown.children(".h_c_s").hide();
  }

  showDropdown () {
    this.elements.dropdown.css('display', 'block');
  }

  viewAllResults (target) {
    let link = $(target).data('link');
    this.elements.container.attr('action', link);
  }

  renderResults (results) {
    this.showDropdown();
    return setTimeout(
      () => {
        var html = '';
        html += this.templates.results.header;
        // Each model that results return for
        results.forEach(result => {
          var modelName = result.from_class.split('\\').pop();
          var isTitles = modelName === 'Titles';
          if (modelName == 'Revenues') {
            modelName = 'Collected Revenue';
          } else if (modelName == 'RevenuesReported') {
            modelName = 'Estimated Revenue';
          } else if (modelName == 'ProducerPayouts') {
            modelName = 'Payouts';
          } else if (modelName == 'PlatformStatuses') {
            modelName = 'Sales &amp; Licensing';
          }
          html += this.templates.results.modelHeader(modelName, result.result_count_total, result.search_result_view_link_format);

          // If there are results to render, show a preview
          if (result.result_count_total > 0) {
            if (result.hasOwnProperty('search_result_mapping')) {
              // For Titles, group by title type
              if (isTitles) {
                html += this.renderTitleResultsGroupedByType(result);
              } else {
                // render each preview result
                var rowHtml = '';
                result.result_chunk.forEach(resultPreview => {
                  resultPreview['t_year_completed'] = '(' + resultPreview['t_year_completed'] + ')';
                  // Render each piece of the preview
                  var colHtml = '';
                  for (const searchResultPreviewKey in result.search_result_mapping) {
                    colHtml += this.templates.results.preview.column(
                      searchResultPreviewKey,
                      resultPreview[result.search_result_mapping[searchResultPreviewKey]],
                    );
                  }
                  rowHtml += this.templates.results.preview.row(
                    resultPreview,
                    colHtml,
                    this.getLinkFromResult(resultPreview, result.search_result_view_link_format),
                    this.getLinkFromResult(resultPreview, result.search_result_edit_link_format),
                    this.getLinkFromResult(resultPreview, result.search_result_view_single_link_format),
                  );
                });
                html += this.templates.results.preview.container(rowHtml);
              }
            }
          }
          //if (result.result_count_total > result.result_count_chunk) { let's make this if more than 1 so it just always shows
          if (result.result_count_total >= 1) {
            html += this.templates.results.viewMoreButton(result.search_result_view_link_format);
          } else {
            html += this.templates.results.noViewMoreEnd();
          }
        });
        this.elements.resultBox.html(html);
      },
      this.data.delayResultsMs,
    );
  }

  /**
   * Render title search results grouped by title type
   * @param {Object} result - The search result object
   * @returns {string} - HTML string
   */
  renderTitleResultsGroupedByType (result) {
    // Group results by title type
    const grouped = {};
    result.result_chunk.forEach(resultPreview => {
      const typeId = resultPreview.t_title_type || 1; // Default to Film if not set
      if (!grouped[typeId]) {
        grouped[typeId] = [];
      }
      grouped[typeId].push(resultPreview);
    });

    let html = '';

    // Render each type group in order
    this.titleTypeOrder.forEach(typeId => {
      if (grouped[typeId] && grouped[typeId].length > 0) {
        const typeName = this.titleTypes[typeId] || 'Other';
        html += this.templates.results.titleTypeHeader(typeName, grouped[typeId].length);

        let rowHtml = '';
        grouped[typeId].forEach(resultPreview => {
          resultPreview['t_year_completed'] = '(' + resultPreview['t_year_completed'] + ')';
          // Render each piece of the preview
          let colHtml = '';
          for (const searchResultPreviewKey in result.search_result_mapping) {
            colHtml += this.templates.results.preview.column(
              searchResultPreviewKey,
              resultPreview[result.search_result_mapping[searchResultPreviewKey]],
            );
          }
          rowHtml += this.templates.results.preview.row(
            resultPreview,
            colHtml,
            this.getLinkFromResult(resultPreview, result.search_result_view_link_format),
            this.getLinkFromResult(resultPreview, result.search_result_edit_link_format),
            this.getLinkFromResult(resultPreview, result.search_result_view_single_link_format),
          );
        });
        html += this.templates.results.preview.container(rowHtml);
      }
    });

    return html;
  }

  setSearchBox (target) {
    this.elements.searchBox = target;
    this.elements.container = target.parent();
    if (this.elements.searchBox.attr('data-isEditLinkEnabled') === 'false') {
      this.data.isEditLinkEnabled = false;
    }
    this.setDropdown(target.parent().find('div.mega'));
  }

  setDropdown (element) {
    this.elements.dropdown = element;
    this.elements.resultBox = element.find('.split.results');
    this.elements.filterBox = element.find('.split.filters');
    this.data.hasFilters = this.elements.filterBox.length > 0;
  }

  setIsLoading (isLoading) {
    this.data.isLoading = isLoading;
    if (isLoading) {
      this.elements.dropdown.show();
      this.elements.resultBox.html(
        this.templates.ajaxLoader,
      );
    }
  };

  setLastSearchValue (value) {
    this.data.lastSearchValue = value;
  }

  getLinkFromResult (model, linkFormat) {
    var regex = new RegExp('{{(.*?)}}', 'g');
    let match;
    while ((match = regex.exec(linkFormat)) !== null) {
      linkFormat = linkFormat.replaceAll(match[0], model[match[1]]);
    }
    return linkFormat;
  }

  getFilterData () {
    let formElements = this.elements.filterBox.find('input, select').toArray();
    let filterData = {};

    formElements.forEach(element => {
      element = $(element);
      if (typeof element.attr('name') !== 'undefined' && element.val() !== '') {
        filterData[element.attr('name')] = element.val();
      }
    });

    return filterData;
  }
};

window.sflow = window.sflow || {};
window.sflow.search = new Search();